import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CustomModalTeamLead from "./CustomModalTeamLead";
import { RiTeamFill } from "react-icons/ri";
import { getUsers } from "store/user/userThunk";
import { useDispatch, useSelector } from "react-redux";
import { addTeamLead } from "store/teamLead/teamLeadThunk";
import DeleteTeamLeadModal from "./DeleteTeamLeadModal";
import TeamLeadDetails from "./TeamLeadDetails";
import { fetchWorkersAction } from "store/worker/workerThunk";
import { getTeamLead } from "store/teamLead/teamLeadThunk";
import { getUnassignedBots } from "store/worker/workerThunk";

export default function MainTeamLead({ color }) {
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [teamLeadInfo, setTeamLeadInfo] = useState(null);
  const [teamLeadToDelete, setTeamLeadToDelete] = useState(null);
  const [currentTeamLead, setCurrentTeamLead] = useState(null);

  const dispatch = useDispatch();
  const { usersDetails } = useSelector((state) => state.user);
  let teamLeadsDetails = usersDetails?.team_leads || [];

  // Sort team leads based on their status
  teamLeadsDetails = (function sortTeamLeadsOnStatus(teamLeads) {
    const activeTeamLeads = teamLeads.filter(
      (teamLead) => teamLead.isActive === true
    );
    const inactiveTeamLeads = teamLeads.filter(
      (teamLead) => teamLead.isActive === false
    );
    return [...activeTeamLeads, ...inactiveTeamLeads];
  })(teamLeadsDetails); // Call the function immediately with teamLeadsDetails

  const all_Agents = usersDetails?.all_agents || [];
  const unassignedAgents = all_Agents.filter(
    (agent) => agent.assigned_to_name === null
  );
  const { unAssignedBotsData } = useSelector((state) => state.worker) || [];
  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleAddTeamLead = (newTeamLead) => {
    dispatch(
      addTeamLead({
        newTeamLead,
        onSuccess: () => {
          dispatch(getUsers());
        },
      })
    );
  };

  const handleDetailClick = (teamLead) => {
    dispatch(fetchWorkersAction());
    dispatch(getUnassignedBots());
    dispatch(getTeamLead(teamLead.Id)).then(() => {
      setTeamLeadInfo(teamLead);
      setShowDetailsModal(true);
    });
  };

  const handleDeleteClick = (teamLead) => {
    setTeamLeadToDelete(teamLead);
    setShowDeleteModal(true);
  };

  return (
    <>
      <div className="worker_main_container">
        <div className="flex justify-end">
          <button
            className="button_worker"
            onClick={() => {
              setCurrentTeamLead(null);
              toggleModal();
            }}
          >
            Add Team Lead
          </button>
        </div>

        <div className="card-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
          {teamLeadsDetails.map((lead) => (
            <div
              key={lead.Id}
              className={`card h-[320px] w-[250px] shadow-md rounded-lg p-4 flex flex-col justify-between ${
                lead.isActive === false ? "bg-gray-300" : "bg-white"
              }`}
            >
              <div className="card-header flex-grow flex flex-col items-center justify-center">
                <div className="bot-img flex justify-center">
                  <RiTeamFill
                    className={`text-6xl ${
                      lead.isActive ? "text-blue-500" : "text-gray-500"
                    }`}
                    size={50}
                  />
                </div>
                <div className="flex flex-col gap-2 items-center text-center">
                  <p className="font-semibold text-base">
                    {lead.first_name} {lead.last_name}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">{lead.Email}</p>
                </div>
              </div>
              <div className="flex justify-between gap-4">
                <button
                  onClick={() => handleDetailClick(lead)}
                  className={`flex items-center justify-center gap-2 w-[50%] rounded-lg text-center text-white px-4 py-2 ${
                    lead.isActive === false
                      ? "bg-gray-500 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-700"
                  }`}
                  disabled={lead.isActive === false}
                >
                  Details
                </button>
                <button
                  onClick={() => handleDeleteClick(lead)}
                  className={`flex items-center justify-center gap-2 w-[50%] rounded-lg text-center text-white px-4 py-2 ${
                    lead.isActive === false
                      ? "bg-gray-500 cursor-not-allowed"
                      : "bg-red-500 hover:bg-red-700"
                  }`}
                  disabled={lead.isActive === false}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Add Team Lead Modal */}
      {showModal && (
        <CustomModalTeamLead
          toggleModal={toggleModal}
          addTeamLead={handleAddTeamLead}
          currentTeamLead={currentTeamLead}
        />
      )}

      {/* Delete Team Lead Modal */}
      {showDeleteModal && (
        <DeleteTeamLeadModal
          toggleModal={() => setShowDeleteModal(false)}
          teamLeadData={teamLeadToDelete}
        />
      )}

      {/* Details Modal */}
      {showDetailsModal && (
        <TeamLeadDetails
          toggleModal={() => setShowDetailsModal(false)}
          unassignedAgents={unassignedAgents}
          teamLeadData={teamLeadInfo}
          unAssignedBots={unAssignedBotsData || []}
        />
      )}
    </>
  );
}

MainTeamLead.defaultProps = {
  color: "light",
};

MainTeamLead.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
